import { DressupClothing } from "GameObjects/StoryGame/ch1/DressupClothing";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { Mix } from "Utils/Reflection";

const radius = 150;

export class AppleTarget extends PIXI.Container {

    // public isBusy: boolean = false;

    // constructor() {
    //     super();
    // }

    // public onLayout() {
    //     this.hitArea = new PIXI.Circle(0, 0, radius);
    // }

    // public consume(pDraggable: HLF.Input.Draggable) {
    //     this.addDraggable(pDraggable);
    // }

    // protected addDraggable(pDraggable: HLF.Input.Draggable) {
    //     super.addDraggable(pDraggable);
    //     PubSub.publishSync('drop', {item: pDraggable, target: this});
    //     // this.isActive = false;
    //     this._eventData = undefined;
    //     this._dragged = undefined;
    //     this._selected = undefined;
    //     this._isPointerOver = false;
    //     this.interactive = false;
    //     console.log('drop', {item: pDraggable, target: this});
    // }

    // protected onDragBegin(pTopic: string, pDraggable: HLF.Input.Draggable) {
    //     super.onDragBegin(pTopic, pDraggable);
    // }

    // protected onDraggableSelected(pTopic: string, pDraggable: HLF.Input.Draggable) {
    //     super.onDraggableSelected(pTopic, pDraggable);
    // }

    // protected onPointerOver(): void {
    //     super.onPointerOver();
    //     // dragging over
    //     if (this._dragged) {
    //         PubSub.publishSync('hover', {item: this._dragged, target: this});
    //     }

    //     // mouse over while item is selected
    //     else if (this._selected) {
    //         PubSub.publishSync('hover', {item: this._selected, target: this});
    //     }
    // }

    // protected onPointerOut(): void {
    //     super.onPointerOut();

    //     if (this._dragged) {
    //         PubSub.publishSync('hoverend', {item: this._dragged, target: this});
    //     }

    //     // mouse over while item is selected
    //     else if (this._selected) {
    //         PubSub.publishSync('hoverend', {item: this._selected, target: this});
    //     }
    // }
}